import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Lock, ArrowLeft, Eye } from "lucide-react";

export const RequireRole = ({ children, roles = [], fallback = null }) => {
  const { user } = useAuth();
  const userRole = user?.role || "user";
  
  if (roles.length === 0 || roles.includes(userRole)) {
    return children;
  }
  
  if (fallback) return fallback;
  
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="access-denied">
      <div className="text-center max-w-md">
        <Lock className="h-12 w-12 text-slate-400 mx-auto mb-4" />
        <h2 className="text-xl font-bold mb-2">Access Restricted</h2>
        <p className="text-slate-500 mb-6">
          This feature requires {roles.join(" or ")} access. Contact your administrator for permissions.
        </p>
        <Link to="/dashboard">
          <Button variant="outline"><ArrowLeft className="h-4 w-4 mr-2" /> Back to Dashboard</Button>
        </Link>
      </div>
    </div>
  );
};

export const DemoRestricted = ({ children }) => {
  const { user } = useAuth();
  
  if (user?.role === "demo") {
    return (
      <div className="relative">
        <div className="pointer-events-none opacity-60">{children}</div>
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm rounded-lg" data-testid="demo-overlay">
          <div className="text-center p-6">
            <Eye className="h-8 w-8 text-blue-500 mx-auto mb-3" />
            <p className="font-medium">Demo Mode — View Only</p>
            <p className="text-sm text-slate-500 mt-1">Request membership for full access</p>
            <Link to="/contact">
              <Button size="sm" className="mt-3">Request Access</Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
  
  return children;
};
